import barba from '@barba/core';

export function addContactListeners() {
  const entries = [contact_name, contact_email, contact_message];
	
  // checks for change in input field
  entries.forEach(entry => {
    entry.addEventListener('change', () => {
      checkValue(entry)
    })
  });
  
  // checks if all input fields pass the requirements
  contact_btn.addEventListener('click', (e) => {
		e.preventDefault();

    if (checkFields(entries)) {
      sendEmail(entries, contact_btn)
    }
  })
}

/**
 * Checks if the entry value meets the requirements.
 * @param {HTMLElement} entry 
 * @returns {boolean}
 */
function checkValue(entry) {
  let pass = true;
  let message;
  const email_regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  if (entry.type == 'text') {
    message = 'You need to provide a name.'
  } else if (entry.type == 'email') {
    message = 'You need to provide an email.'
  } else if (entry.type == 'textarea') {
    message = 'You need to provide a message.'
  }
  
  if (!entry.value) {
    pass = false;
    showFieldError(true, entry, message)
  } else {
    if (entry.type == 'email' && !email_regex.test(entry.value)) {
      pass = false;
      showFieldError(true, entry, 'You need to provide a proper email.')
    } else {
      showFieldError(false, entry)
    }
  }
  
  return pass
}

/**
 * Checks if all the input fields pass the requirement.
 * @param {Array.<HTMLElement>} entries 
 * @returns {boolean}
 */
function checkFields(entries) {
  let pass = true;

  entries.forEach(entry => {
    if (!checkValue(entry)) {
      pass = false
    }
  });
  
  return pass
}

/**
 * Shows an error message if the field value did not meet the requirements.
 * @param {boolean} remove 
 * @param {HTMLElement} entry 
 * @param {string} [message] 
 */
function showFieldError(remove, entry, message) {
  if (remove) {
    entry.previousElementSibling.children[0].innerText = '* ' + message
  } else {
    entry.previousElementSibling.children[0].innerText = '*';
  }
}

/**
 * Changes form state according to the phases of data submission.
 * @param {string} state 
 * @param {Array.<HTMLElement>} [entries]
 */
function changeFormState(state, entries) {
  if (state == 'sending') {
    entries.forEach(entry => {
      entry.style = 'pointer-events:none;opacity:.5'
    });

    contact_btn.style = 'pointer-events:none;opacity:.5';
    contact_btn.innerText = 'sending...'
  } else if (state == 'success') {
		barba.go('/contact/success')
  } else if (state == 'error') {
		barba.go('/contact/error')
  }
}

/**
 * Creates a fake hidden form and uses it to send the data over to the email request.
 * @param {Array.<HTMLElement>} entries
 */
function sendEmail(entries) {
  changeFormState('sending', entries);

  const formdata = new FormData();
  formdata.append('name', entries[0].value);
  formdata.append('email', entries[1].value);
  formdata.append('message', entries[2].value);

  fetch("https://hook.eu1.make.com/hu3p4nwk460fmupwujovbmb9fgnlnhpf", {
    method: 'POST', body: formdata
  })
  .then(res => res.text())
  .then(res => {
    if (res == 'Accepted') {
      changeFormState('success')
    } else {
      changeFormState('error', null)
    }
  }).catch(() => {
    changeFormState('error', null)
  })
}